import { render, staticRenderFns } from "./edit-sensor.dialog.component.vue?vue&type=template&id=1d037fe0"
import script from "./edit-sensor-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./edit-sensor-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d037fe0')) {
      api.createRecord('1d037fe0', component.options)
    } else {
      api.reload('1d037fe0', component.options)
    }
    module.hot.accept("./edit-sensor.dialog.component.vue?vue&type=template&id=1d037fe0", function () {
      api.rerender('1d037fe0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/iot-dialog/edit-sensor.dialog.component.vue"
export default component.exports